import React, { Component } from 'react';

import UIUtils from "../util/UIUtils";
import "../styles/header.css";
import "./PageHeader.css";
import DelegateWithSmartStake from './DelegateWithSmartStake';
import RespUtils from '../util/RespUtils';
import Special from './Special';

class PageHeader extends Component {

  render() {
    return (
        <div className="subHeader">
            <div className="subHeader__group">
              <div className="pageTitle">
                {this.props.logo != null ? this.props.logo(): ""}&nbsp;
                {this.props.title}{this.props.beta && this.props.beta === true && <span className="beta">BETA</span>}
              </div>
              {this.props.delegateLink && this.getStakeFormatter()}
            </div>
            <Special />
            {this.props.notification != false && UIUtils.getNotification(this.props.thisObj.state.notification)}
        </div>
    );
  }
  // 

  getStakeFormatter() {
    if (RespUtils.isTabletView()) {
      return "";
    }

    return (
      <div className="headerActions">
        <DelegateWithSmartStake />
      </div>
    )
  }
}
// {UIUtils.renderPageActions(this, true, true)}

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/PageHeader.js